/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrderApproveRequest } from '../types/PatchedOrderApprove';
import type { OrderApproveResponse } from '../types/OrderApprove';

export type OrdersApprovePartialUpdateRequest = PatchedOrderApproveRequest;
export type OrdersApprovePartialUpdateResponse = OrderApproveResponse;

export type OrdersApprovePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/orders/{id}/approve/
 *
 * ```yaml
 * operationId: orders_approve_partial_update
 * description: |-
 *   Pro zamitnuti
 *   { "state": "REJECTED",
 *     "rejection_reason": "Duvod zamitnuti", }
 *
 *   Pro schvaleni
 *   {"state": "APPROVED", "approval_id": "949"}
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderApprove'
 *     description: ''
 * ```
 */
export const ordersApprovePartialUpdateOperation = ({
  id,
  ...rest
}: OrdersApprovePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/orders/${id}/approve/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/approve/' };
  };

/**
 * PATCH /dmx-server/orders/{id}/approve/
 *
 * ```yaml
 * operationId: orders_approve_partial_update
 * description: |-
 *   Pro zamitnuti
 *   { "state": "REJECTED",
 *     "rejection_reason": "Duvod zamitnuti", }
 *
 *   Pro schvaleni
 *   {"state": "APPROVED", "approval_id": "949"}
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderApprove'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderApprove'
 *     description: ''
 * ```
 */
export const ordersApprovePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersApprovePartialUpdateQuery;
  request: PatchedOrderApproveRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderApproveResponse>> => {
  const operation = ordersApprovePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
